export {
    default as Heatmap,
    IHeatmapProps,
} from './heatmap';
